if (location.href.indexOf('#/wflow?') === -1) {
    module.exports = file => resolve => require(['@/wapp/' + file + '.vue'], resolve).default
} else {
    module.exports = file => require('@/wapp/' + file + '.vue').default
}
